import script from "./AgentReplyDraft.vue?vue&type=script&setup=true&lang=ts"
export * from "./AgentReplyDraft.vue?vue&type=script&setup=true&lang=ts"

import "./AgentReplyDraft.vue?vue&type=style&index=0&id=40cc60dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40cc60dc"]])

export default __exports__